module.exports = __webpack_public_path__ + "static/media/july-show.ef1b855e.jpg";